import React from 'react';

import Templates from '../FormFields/Templates';
import Description from '../FormFields/Description';
import WhenShouldBeCompleted from '../FormFields/When/WhenShouldBeCompleted';
import Who from '../FormFields/Who/Who';
import Resources from '../FormFields/Resources';
import Error from '../Error';

export const Task = () => {
  return (
    <div className="activity_modal">
      <Templates />
      <Description />
      <WhenShouldBeCompleted />
      <Resources />
      <Who /> {/* NOTE: Keep Who as the last element of ActivityModal */}
      <Error />
    </div>
  );
};

export default Task;
